import React from "react"
import { FIELD_ITEMS } from "../content"

// I pezzi d'app fermi del sito, quelli che non serve toccare: si guardano
// e basta. Nomi inventati.

export function DemoSheet() {
	return (
		<div className="demo demo-card">
			<div className="demo-month-head">
				<b>Marco Bassi</b>
				<span className="demo-muted">Scheda tecnica</span>
			</div>
			<div className="demo-sheet-row">
				<span className="demo-muted">Livello PTR</span>
				<b>3.5</b>
			</div>
			<div className="demo-sheet-row">
				<span className="demo-muted">Che giocatore è</span>
				<b>Attaccante da fondo</b>
			</div>
			<div className="demo-sheet-row is-column">
				<span className="demo-muted">Su cosa lavora</span>
				<span className="demo-tags">
					<span>Rovescio</span>
					<span>Gioco a rete</span>
				</span>
			</div>
		</div>
	)
}

const TEAM = [
	{ initials: "GR", name: "Giorgia Rossi", role: "Gestore", color: "var(--c-gunmetal-fill)" },
	{ initials: "MB", name: "Marco Bianchi", role: "Collega", color: "var(--c-accent)" },
	{ initials: "SL", name: "Sara Lodi", role: "Osservatore", color: "var(--c-cad-fill)" },
	{ initials: "TF", name: "Tommaso Fini", role: "Su misura", color: "var(--c-primary)" },
]

export function DemoRoles() {
	return (
		<div className="demo demo-card">
			{TEAM.map(person => (
				<div key={person.name} className="demo-team-row">
					<span className="demo-avatar" style={{ background: person.color }}>
						{person.initials}
					</span>
					<span className="demo-team-name">{person.name}</span>
					<span className="demo-chip is-quiet">{person.role}</span>
				</div>
			))}
		</div>
	)
}

export function DemoLog() {
	return (
		<div className="demo demo-card demo-log">
			<p>
				<b>Giorgia</b> ha spostato la lezione delle 18 alle 19 ·{" "}
				<span className="demo-muted">ieri, 21:40</span>
			</p>
			<p>
				<b>Marco</b> ha eliminato la privata di giovedì · <span className="demo-orange">Rimetti</span>
			</p>
		</div>
	)
}

export function DemoField() {
	return (
		<div className="demo demo-field">
			{FIELD_ITEMS.map(item => (
				<div key={item.title} className="demo-card">
					<b>{item.title}</b>
					<p>{item.text}</p>
				</div>
			))}
		</div>
	)
}
